import { Spinner, Stack } from "@chakra-ui/react";
import { OperationListError } from "./OperationListError.tsx";

interface Props {
  isFetching: boolean;
  isError: boolean;
  count: number;
  refetch: () => void;
}

export function OperationListFooter({ isFetching, isError, count, refetch }: Props) {
  return (
    <>
      {isFetching && (
        <Stack h="82px" pb="8px" alignItems="center" justifyContent="center">
          <Spinner />
        </Stack>
      )}

      {!isFetching && isError && count > 0 && (
        <Stack pb="8px">
          <OperationListError refetch={refetch} />
        </Stack>
      )}
    </>
  );
}
